










































import {
  defineComponent,
  WritableComputedOptions,
  computed,
  watch,
  getCurrentInstance,
  onMounted,
  onUnmounted,
} from '@vue/composition-api';
import { ChevronLeftCircleIcon, CaretDownSmallIcon, CaretUpSmallIcon, ChevronRightCircleIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import { fileTypeToWording, FileSelectHandler } from '@/renderer/components/drawer/compositions/fileSelectHandler';
import { FileType } from '@/renderer/components/drawer/compositions/fileType';
import { GetDropdownItemShortCutText } from '@/renderer/scripts/utils/hotkeyDataHelper';

export default defineComponent({
  name: 'FileListIndicator',
  components: {
    ChevronLeftCircleIcon,
    CaretDownSmallIcon,
    CaretUpSmallIcon,
    ChevronRightCircleIcon,
  },
  props: {
    handler: {
      required: true,
      type: Object,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const fileSelectHandler = props.handler as FileSelectHandler;

    // 文件类型的文案
    const filterTypeText = computed(() => {
      const allTypeList = fileSelectHandler.allFileTypeList.value;
      const uniqueTypeCount = allTypeList.length;
      const filterFileType = fileSelectHandler.filterFileTypeList.value;
      const filterFileTypeCount = filterFileType.length;
      if (filterFileTypeCount === uniqueTypeCount) {
        return i18n_t('全部');
      }
      if (filterFileTypeCount === 1) {
        return fileTypeToWording(filterFileType[0]);
      }
      return i18n_t('{slot1}项', {
        slot1: filterFileTypeCount,
      });
    });

    // 展示的当前文件序号，找不到时为0
    const currentIndexShow = computed(() => {
      const selectedFile = fileSelectHandler.selectedFile.value;
      const filteredFileList = fileSelectHandler.filteredFileList.value;
      if (!selectedFile) return 0;
      return filteredFileList.map(it => it.file.name).indexOf(selectedFile.file.name) + 1;
    });
    // 真实的文件序号
    const currentIndexReal = computed(() => currentIndexShow.value - 1);
    // 所有文件数
    const totalFileCount = computed(() => fileSelectHandler.filteredFileList.value.length);
    // 是否可以切换到上一个文件
    const isLeftDisabled = computed(() => currentIndexShow.value <= 1);
    // 是否可以切换到下一个文件
    const isRightDisabled = computed(() => currentIndexShow.value >= fileSelectHandler.filteredFileList.value.length);
    // 内容是否展开
    const isContentExpanded = computed(() => fileSelectHandler.shouldShowFileSelector.value);
    const methods = {
      handleChangePage(direction: 'previous' | 'next') {
        if (direction === 'previous') {
          methods.handlePrevioursClick();
        } else if (direction === 'next') {
          methods.handleNextClick();
        }
      },
      handlePrevioursClick() {
        const previoursIndex = currentIndexReal.value - 1;
        if (previoursIndex >= 0) {
          fileSelectHandler.selectedFile.value = fileSelectHandler.filteredFileList.value[previoursIndex];
        }
      },
      handleNextClick() {
        const nextIndex = currentIndexReal.value + 1;
        const maxIndex = fileSelectHandler.filteredFileList.value.length;
        if (nextIndex < maxIndex) {
          fileSelectHandler.selectedFile.value = fileSelectHandler.filteredFileList.value[nextIndex];
        }
      },
      handleDropDownClick() {
        fileSelectHandler.shouldShowFileSelector.value = !fileSelectHandler.shouldShowFileSelector.value;
      },
    };
    watch(
      () => [fileSelectHandler.manulFilterTypeList.value, fileSelectHandler.allFileTypeList.value],
      ([manulFilterTypeList, allFileTypeList]) => {
        fileSelectHandler.updateFilterFileTypeList(manulFilterTypeList, allFileTypeList as FileType[]);
      },
      {
        immediate: true,
      },
    );
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.PREVIEW_CHANGE_PAGE, methods.handleChangePage);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.PREVIEW_CHANGE_PAGE, methods.handleChangePage);
    });
    return {
      filterTypeText,
      currentIndexShow,
      totalFileCount,
      isLeftDisabled,
      isRightDisabled,
      isContentExpanded,
      methods,
      GetDropdownItemShortCutText,
    };
  },
});
